import type { SVGProps } from 'react';

export function SwitcherChevronsIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      className={className}
      {...props}
    >
      <path d="m12 22c-.3 0-.5-.1-.7-.3l-5-5c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l4.3 4.3 4.3-4.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-5 5c-.2.2-.4.3-.7.3z" />
      <path d="m7 9c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l5-5c.4-.4 1-.4 1.4 0l5 5c.4.4.4 1 0 1.4s-1 .4-1.4 0l-4.3-4.3-4.3 4.3c-.2.2-.4.3-.7.3z" />
    </svg>
  );
}

export default SwitcherChevronsIcon;
